import { type PropsWithChildren } from 'react'

import { useOnboarding } from '../hooks/use-onboarding'

import { OnboardingContext } from './onboarding-context'

export function OnboardingProvider({ children }: PropsWithChildren) {
  const onboardingState = useOnboarding()

  return (
    <OnboardingContext.Provider value={onboardingState}>
      {children}
    </OnboardingContext.Provider>
  )
}
